@if (selectionMode$ | async) {
    <frog-selection></frog-selection>
}
